import { Col, Form, Input, Row, Typography } from 'antd';
import { cleanString } from 'helpers/functions';
import { cpfMask, phoneMask } from 'helpers/masks';
import { validateCpf, validateEmail } from 'helpers/validations';
import styles from './styles.module.css';
import CustomFieldsForm from 'components/Shared/CustomFieldsForm';
import { EventAttendanceCustomFields } from 'interfaces/event';

interface FormProps {
  index: number;
  ticketName: string;
  lotName: string;
  customFields?: EventAttendanceCustomFields[];
}

const baseRules = [
  { required: true, message: 'Campo obrigatório' },
  { whitespace: true, message: 'O campo não pode estar vazio' },
];

export const NewForm = ({ index, ticketName, lotName, customFields }: FormProps) => {
  const namePath = (field: string) => `products-${index}-${field}`;

  const hasCustomFields = customFields?.length > 0;

  return (
    <div className={styles.wrapper} id={`wrapper-form-${index}`}>
      <Typography.Title level={5}>
        {ticketName} - {lotName}
      </Typography.Title>
      <Row gutter={[15, 10]}>
        <Col xs={24} sm={24} md={12}>
          <Form.Item
            name={namePath('name')}
            label='Nome'
            required
            rules={[...baseRules, { pattern: /^[A-zÀ-ú\s]+$/, message: 'Insira apenas letras' }]}
          >
            <Input placeholder='Insira o nome' id={`name-input-${index}`} />
          </Form.Item>
        </Col>

        <Col xs={24} sm={24} md={12}>
          <Form.Item
            name={namePath('document')}
            label='CPF'
            required
            normalize={cpfMask}
            rules={[
              ...baseRules,
              {
                validator(_, value) {
                  const cpf = cleanString(value);
                  if (validateCpf(cpf) || !cpf) return Promise.resolve();
                  return Promise.reject(new Error('CPF informado é inválido'));
                },
              },
            ]}
          >
            <Input placeholder='Insira o CPF' maxLength={20} id={`doc-input-${index}`} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[15, 10]}>
        <Col xs={24} sm={24} md={12}>
          <Form.Item
            name={namePath('email')}
            label='E-mail'
            required
            rules={[
              ...baseRules,
              () => ({
                validator(_, value) {
                  if (validateEmail(value)) {
                    return Promise.resolve();
                  }

                  return Promise.reject(new Error('Endereço inválido, revise o e-mail inserido'));
                },
              }),
            ]}
          >
            <Input placeholder='Insira o e-mail' type='email' id={`enail-input-${index}`} />
          </Form.Item>
        </Col>

        <Col xs={24} sm={24} md={12}>
          <Form.Item
            name={namePath('phone')}
            label='Celular'
            required
            normalize={phoneMask}
            rules={[...baseRules, { min: 15, message: 'Celular inválido' }]}
          >
            <Input placeholder='Insira o celular' maxLength={20} id={`phone-input-${index}`} />
          </Form.Item>
        </Col>
      </Row>
      {hasCustomFields && (
        <Row gutter={[10, 8]}>
          {customFields.map(field => (
            <CustomFieldsForm
              key={`${field.name}-${index}`}
              config={field}
              customName={namePath(`custom_field_${field.name}`)}
            />
          ))}
        </Row>
      )}
    </div>
  );
};
